import { Platform } from 'react-native';

import { routes } from '@fhs-legacy/frontend/src/utils/routing';

export function getOffersAndRewardsHref(enableRewardsTiers: boolean) {
  // TODO: Remove the flag parameter and legacy Offers fallback when the
  // enable-rewards-tiers flag is fully retired from the menu experience.
  // Keep the combined native experience inside the Rewards tab; web and legacy Offers
  // continue using the standalone route.
  return enableRewardsTiers && Platform.OS !== 'web' ? routes.rewardsTab : routes.offersV2;
}
